import axios from 'axios';
import { API_BASE_URL } from '../../constants/config';
import { VerifyAnalyticsResponse } from '../../types/auth';
import {getAndSanitize} from '../../shared/utils/sanitization';

const api = axios.create({
  baseURL: `${API_BASE_URL}/api/auth`,
});

// Configurar el interceptor para incluir el token en todas las peticiones
api.interceptors.request.use((config) => {
  const token = getAndSanitize('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

  
export const authApi = {
  login: async (credentials: { username: string; password: string }) => {
    const response = await api.post('/login', credentials);
    return response.data;
  },

  verifyAnalyticsPassword: async (analyticsPassword: string): Promise<VerifyAnalyticsResponse> => {
    const userId = getAndSanitize('userId');
    const response = await api.post('/verify-analytics-password', { 
      analyticsPassword,
      userId
    });
    return response.data;
  },

  verify2FA: async (data: { userId: string; code: string }) => {
    const response = await api.post('/verify-2fa', data);
    return response.data;
  }
};